import React from "react";
import { useCart } from "@/context/CartContext";
import { BULK_TIERS, FREE_SHIP_THRESHOLD, money } from "@/data/products";
import { Truck, TrendingUp } from "lucide-react";

// Nearest per-line bulk tier the shopper hasn't hit yet.
const nextBulkTier = (qty) => {
  const sorted = [...BULK_TIERS].sort((a, b) => a.min - b.min);
  return sorted.find((t) => qty < t.min) || null;
};

export const CartNudges = () => {
  const { lines, updateQty, freeShip, freeShipRemaining } = useCart();
  if (lines.length === 0) return null;

  // Bulk-tier nudges — surface lines within 3 vials of the next discount tier
  const bulkNudges = lines
    .map((l) => {
      const t = nextBulkTier(l.qty);
      if (!t) return null;
      const need = t.min - l.qty;
      return need > 0 && need <= 3 ? { line: l, tier: t, need } : null;
    })
    .filter(Boolean)
    .slice(0, 2);

  return (
    <div className="space-y-3 mb-5" data-testid="cart-nudges">
      {/* Free shipping progress */}
      <div className="border border-zinc-800 bg-[#0C0C0C] px-4 py-3 flex items-center gap-2" data-testid="free-ship-nudge">
        <Truck size={14} color="#D4AF37" />
        {freeShip
          ? <p className="font-mono text-[11px] text-emerald-400" data-testid="free-ship-unlocked">Free shipping unlocked</p>
          : <p className="font-mono text-[11px] text-[#A1A1AA]" data-testid="free-ship-progress">Add <span className="text-[#D4AF37]">{money(freeShipRemaining)}</span> more for free shipping (${FREE_SHIP_THRESHOLD}+)</p>}
      </div>

      {/* Bulk-tier nudges */}
      {bulkNudges.map(({ line, tier, need }) => (
        <div key={line.id} className="flex items-center justify-between gap-3 border border-zinc-800 bg-[#0C0C0C] px-4 py-3"
          data-testid={`bulk-nudge-${line.id}`}>
          <p className="font-mono text-[11px] text-[#A1A1AA] min-w-0">
            <TrendingUp size={12} className="inline mr-1.5 -mt-0.5 text-[#D4AF37]" />
            Add {need} more {line.name.split(" ")[0]} to unlock <span className="text-emerald-400">{Math.round(tier.off * 100)}% off</span>
          </p>
          <button onClick={() => updateQty(line.id, tier.min)} data-testid={`bulk-nudge-add-${line.id}`}
            className="shrink-0 border border-zinc-700 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
            +{need}
          </button>
        </div>
      ))}
    </div>
  );
};
